import { Quotation } from './types';

// Backend integration point: replace localStorage with API calls
const STORAGE_KEY = 'tgi_quotations';
const SEQUENCE_KEY = 'tgi_quote_sequence';

export function getQuotations(): Quotation[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveQuotations(quotations: Quotation[]): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(quotations));
}

export function getQuotationById(id: string): Quotation | null {
  const quotations = getQuotations();
  return quotations.find((q) => q.id === id) || null;
}

export function upsertQuotation(quotation: Quotation): void {
  const quotations = getQuotations();
  const idx = quotations.findIndex((q) => q.id === quotation.id);
  if (idx >= 0) {
    quotations[idx] = { ...quotation, updatedAt: new Date().toISOString() };
  } else {
    quotations.unshift(quotation);
  }
  saveQuotations(quotations);
}

export function deleteQuotation(id: string): void {
  const quotations = getQuotations().filter((q) => q.id !== id);
  saveQuotations(quotations);
}

export function generateQuoteNumber(): string {
  if (typeof window === 'undefined') return 'TGI/2026/0001';
  const year = new Date().getFullYear().toString();
  const sequenceRaw = localStorage.getItem(SEQUENCE_KEY);
  let sequenceData: { year: string; seq: number } = { year, seq: 0 };
  if (sequenceRaw) {
    try {
      sequenceData = JSON.parse(sequenceRaw);
    } catch { /* ignore */ }
  }
  if (sequenceData.year !== year) {
    sequenceData = { year, seq: 0 };
  }
  sequenceData.seq += 1;
  localStorage.setItem(SEQUENCE_KEY, JSON.stringify(sequenceData));
  const padded = String(sequenceData.seq).padStart(4, '0');
  return `TGI/${year}/${padded}`;
}

export function generateId(): string {
  return `quote-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
}